<template>
  <div class="pure-pagination">
    <!-- <button 
      class="page-btn first"
      :disabled="currentPage === 1"
      @click="changePage(1)"
      title="第一页"
    >
      «
    </button> -->
    
    <button 
      class="page-btn prev border-none" 
      :disabled="currentPage === 1"
      @click="changePage(currentPage - 1)"
      title="上一页"
    >
    <i class="el-icon-arrow-left"></i>
    </button>
    <template v-if="currentPage > 3">
      <button class="page-btn" @click="changePage(1)">1</button>
      <img class="ellipsis" v-if="currentPage > 4" src="@/assets/image/apart/dian.png" width="32" height="32"/> 
    </template>
    
    <button
      v-for="page in visiblePages"
      :key="page"
      class="page-btn"
      :class="{ active: currentPage === page }"
      @click="changePage(page)"
    >
      {{ page }}
    </button>
    
    <template v-if="currentPage < totalPages - 2">
      <img class="ellipsis" v-if="currentPage < totalPages - 3" src="@/assets/image/apart/dian.png" width="32" height="32"/> 
      <button class="page-btn" @click="changePage(totalPages)">{{ totalPages }}</button>
    </template>
    
    <button
      class="page-btn next border-none"
      :disabled="currentPage === totalPages"
      @click="changePage(currentPage + 1)"
      title="下一页"
    >
    <i class="el-icon-arrow-right"></i>
    </button>
    <!-- <button
      class="page-btn last"
      :disabled="currentPage === totalPages"
      @click="changePage(totalPages)"
      title="最后一页"
    >
      »
    </button> -->
  </div>
</template>

<script>
export default {
  props: {
    totalItems: {
      type: Number,
      default: 1000
    },
    perPage: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      currentPage: 1
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalItems / this.perPage)
    },
    visiblePages() {
      const pages = []
      const maxVisible = 3
      let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2))
      let end = Math.min(this.totalPages, start + maxVisible - 1)
      
      if (end - start + 1 < maxVisible) {
        start = Math.max(1, end - maxVisible + 1)
      }
      
      for (let i = start; i <= end; i++) {
        pages.push(i)
      }
      
      return pages
    }
  },
  methods: {
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        // this.currentPage = page
        this.$emit('page-changed', page)
      }
    }
  }
}
</script>

<style scoped>
.pure-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  margin-top: 20px;
  font-size: 14px;
}
.border-none{
  border:none !important;
}
.page-btn {
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  font-size: 14px;
  border: 1px solid #CED4DB;
  border-radius: 4px;
  background: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.page-btn:hover:not(.active):not(:disabled) {
  background: #f5f5f5;
}

.page-btn.active {
  background: var(--tech-primary);
  color: white;
  border:none;
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.first, .last, .prev, .next {
  font-weight: bold;
}

.ellipsis {
  /* margin: 0 5px; */
  transform:scale(0.8);
}
</style>